export const getMapMarkers = (state) => {
  return state.config['map_markers'] ? state.config['map_markers'] : ''
}

export const getExtraFields = (state) => {
  return state.registrationFields
}
